import { ColumnFileList } from '~/entities/common/Car/Documents'
import { AsyncGridColumns, ColumnDate } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.creation date',
    field: 'createdAt',
    sortable: false,
    flex: 1,
    width: 150,
    renderCell: ({ row }) => (
      <ColumnDate type='dateTime' value={row.createdAt} />
    ),
  },
  {
    headerName: 'column.number',
    field: 'number',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.issue date',
    field: 'issuedDate',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => <ColumnDate type='date' value={row.issuedDate} />,
  },
  {
    headerName: 'column.valid until',
    field: 'expirationDate',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => (
      <ColumnDate type='date' value={row.expirationDate} />
    ),
  },
  {
    headerName: 'column.issued by',
    field: 'issuedBy',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.amount',
    field: 'paidAmount',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.documents',
    field: 'files',
    sortable: false,
    minWidth: 120,
    renderCell: ({ row }) => <ColumnFileList files={row.files} />,
  },
]
